import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteInstalledProductAttachmentByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteInstalledProductAttachmentByIdMutation = { __typename?: 'mutation_root', delete_installed_product_attachments_by_pk?: { __typename?: 'installed_product_attachments', id: any } | null };


export const DeleteInstalledProductAttachmentByIdDocument = gql`
    mutation deleteInstalledProductAttachmentById($id: uuid!) {
  delete_installed_product_attachments_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteInstalledProductAttachmentByIdMutationFn = Apollo.MutationFunction<DeleteInstalledProductAttachmentByIdMutation, DeleteInstalledProductAttachmentByIdMutationVariables>;

/**
 * __useDeleteInstalledProductAttachmentByIdMutation__
 *
 * To run a mutation, you first call `useDeleteInstalledProductAttachmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstalledProductAttachmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstalledProductAttachmentByIdMutation, { data, loading, error }] = useDeleteInstalledProductAttachmentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInstalledProductAttachmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInstalledProductAttachmentByIdMutation, DeleteInstalledProductAttachmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInstalledProductAttachmentByIdMutation, DeleteInstalledProductAttachmentByIdMutationVariables>(DeleteInstalledProductAttachmentByIdDocument, options);
      }
export type DeleteInstalledProductAttachmentByIdMutationHookResult = ReturnType<typeof useDeleteInstalledProductAttachmentByIdMutation>;
export type DeleteInstalledProductAttachmentByIdMutationResult = Apollo.MutationResult<DeleteInstalledProductAttachmentByIdMutation>;
export type DeleteInstalledProductAttachmentByIdMutationOptions = Apollo.BaseMutationOptions<DeleteInstalledProductAttachmentByIdMutation, DeleteInstalledProductAttachmentByIdMutationVariables>;